export async function setup() {
  const videoData = [];

  videoData.cdsa = [];
  videoData.cdsa.English = [];
  videoData.cdsa.English.stage1 = require("../assets/video/cdsa/English/stage1.mp4");
  videoData.cdsa.English.stage12 = require("../assets/video/cdsa/English/stage1.mp4");
  return videoData;
}
